<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
        <h3 class="p-2">
            <small class="text-muted">Mail Management Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Module</label>
                <!-- <input type="text" class="form-control" v-model="mm.module" id="module" aria-describedby="module"> -->
                <select type = "dropdown" class="form-control" id="module" v-model="mm.module">
                    <option v-for="(list, index) in this.moduleLists" :key="index" :value="list.value">{{ list.title }}</option>
                </select>
            </div>
            <div class="form-group col-3">
                <label>Action</label>
                <!-- <input type="text" class="form-control" v-model="mm.action" id="action" aria-describedby="action"> -->
                <select type = "dropdown" class="form-control" id="action" v-model="mm.action">
                    <option v-for="(list, index) in this.actionLists" :key="index" :value="list.value">{{ list.title }}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-6">
                <label for="subject">Subject</label>
                <input type="text" class="form-control" v-model="mm.subject" id="subject" aria-describedby="subject">
            </div>
        </div>

        <div class="row">
            <div class="form-group col-6">
                <label for="body">Body</label>
                <textarea class="form-control" v-model="mm.body" id="body" aria-describedby="body"></textarea>
            </div>
            <div class="form-group col-6">
                <label for="footer">Footer</label>
                <textarea class="form-control" v-model="mm.footer" id="footer" aria-describedby="footer"></textarea>
            </div>
        </div>

        <app-datatable :type="'input'" :newData="newDetail" :elements="dtElements" :collections="mm.mailManagementDetail"></app-datatable>
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-warning" @click="cancel" style="margin-left: 20px;">Cancel <i class="far fa-window-close"></i></button>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { mailManagement, mailManagementDetail } from '../../models/mailManagement'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppNavBar from '../../components/AppNavbar.vue'

export default {
    components: {
        AppLookupField, AppDatatable, AppDatePicker, AppNavBar
    },
    data() {
        return {
            mm: {
                ...mailManagement,
                mailManagementDetail: []
            },
            moduleLists: [
                {
                    title: 'Customer Complaint',
                    value: 'customercomplaint'
                },
                {
                    title: 'NCR',
                    value: 'ncr'
                },
                {
                    title: 'Recall',
                    value: 'recall'
                }
            ],
            actionLists: [
                {
                    title: 'CC - Area Owner - Submitted',
                    value: 'areaowner-submitted'
                },
                {
                    title: 'CC - Sales - Log',
                    value: 'cc-sales-log'
                },
                {
                    title: 'CC - Sales - Not Log',
                    value: 'cc-sales-not-log'
                },
                {
                    title: 'CC - Customer - Reply - Sales',
                    value: 'cc-customer-reply-sales'
                },
                {
                    title: 'CC - Quality - Approve',
                    value: 'cc-quality-approve'
                },
                {
                    title: 'CC - Quality - Reject',
                    value: 'cc-quality-reject'
                },
                {
                    title: 'CC - Customer - Reply - Quality',
                    value: 'cc-customer-reply-quality'
                },
                {
                    title: 'CC - CPAR - Sent',
                    value: 'cc-cpar-sent'
                },
                {
                    title: 'CC - Customer - Approve',
                    value: 'cc-customer-approve'
                },
                {
                    title: 'CC - Customer - Reject',
                    value: 'cc-customer-reject'
                },
                {
                    title: 'CC - User - Submitted',
                    value: 'user-submitted'
                },
                {
                    title: 'CC/NCR - Corrective - Submitted',
                    value: 'corrective-submitted'
                },
                {
                    title: 'CC - Submitted',
                    value: 'submitted'
                },
                {
                    title: 'CC - Declined',
                    value: 'cc-declined'
                },
                {
                    title: 'CC/Recall - Head Dept - Approval',
                    value: 'approval-head-dept'
                },
                {
                    title: 'CC/Recall - QA Manager - Approval',
                    value: 'approval-qa-manager'
                },
                {
                    title: 'CC/Recall - Sales Manager - Approval',
                    value: 'approval-sales-manager'
                },
                {
                    title: 'CC/Recall - Manuf Director - Approval',
                    value: 'approval-director'
                },
                {
                    title: 'CC/Recall - Ops Director - Approval',
                    value: 'approval-ops-director'
                },
                {
                    title: 'CC/Recall - Managing Director - Approval',
                    value: 'approval-managing-director'
                },
                {
                    title: 'Recall - Declined',
                    value: 'recall-declined'
                },
                {
                    title: 'NCR - Submitted',
                    value: 'ncr-user-submitted'
                },
                {
                    title: 'Scheduler - Dashboard Report',
                    value: 'scheduler-dashboard-report'
                },
            ],
            newDetail: mailManagementDetail ,
            //   ini untuk lookup master data
            // vendorLookup: {
            //     id: 'vendor',
            //     title: 'Data Pemasok',
            //     type: 'form',
            //     apiUrl: 'vendor',
            //     filter: ['code', 'name'],
            //     fields: [
            //         {
            //             placeholder: 'Kode Pemasok',
            //             width: 2,
            //             column: 'vendorCode'
            //         },
            //         {
            //             placeholder: 'Nama Pemasok',
            //             width: 4,
            //             column: 'vendorName'
            //         }
            //     ],
            //     dtElements: [
            //         {
            //             title: 'Kode',
            //             column: 'code'
            //         },
            //         {
            //             title: 'Nama',
            //             column: 'name'
            //         },
            //     ],
            //     affectedField: [
            //         {
            //             from: 'id',
            //             to: 'vendorId'
            //         },
            //         {
            //             from: 'code',
            //             to: 'vendorCode'
            //         },
            //         {
            //             from: 'name',
            //             to: 'vendorName'
            //         }
            //     ]
            // },
            dtElements: [
                // ini untuk lookup master data di dlm DT
                {
                    title: 'Email',
                    column: 'email',
                    type: 'lookup',
                    width: 6,
                    lookup: {
                        id: 'member',
                        title: 'Data Member',
                        type: 'table',
                        apiUrl: 'member-management/lookup',
                        filter: ['firstName', 'lastName', 'email'],
                        fields: [
                            {
                                placeholder: 'Member Name',
                                width: 5,
                                column: 'email'
                            }
                        ],
                        dtElements: [
                            {
                                title: 'First Name',
                                column: 'firstName'
                            },
                            {
                                title: 'Last Name',
                                column: 'lastName'
                            },
                            {
                                title: 'Email',
                                column: 'email'
                            },
                        ],
                        affectedField: [
                            {
                                from: 'email',
                                to: 'email'
                            },
                        ]
                    },
                    disable: true,
                },
                {
                    title: 'Type',
                    column: 'type',
                    type: 'dropdown',
                    width: 4,
                    lists: [
                        {
                            title: 'To',
                            value: 'to'
                        },
                        {
                            title: 'CC',
                            value: 'cc'
                        }
                    ]
                }
            ]
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const mmApi = api('mail-management')
            this.mm = await mmApi.getWithParams(this.$route.query.id)
        }
        console.log(this.mm.module)
    },
    methods: {
        async save() {
            const mmApi = api('mail-management')
            if(this.$route.query.id !== undefined) {
                await mmApi.update(this.mm, this.$route.query.id)
            } else {
                await mmApi.create(this.mm)
                
            }
            this.$router.go(-1)
        },
        cancel() {
            this.$router.go(-1)
        },
        finishLookup(data) {
            const currentMM = this.mm
            this.mm = {
                ...currentMM,
                ...data
            }
        }
    }
}
</script>